export default __webpack_public_path__ + "static/media/hashtag_volume.978c63f1.svg";